import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import scriptLoader from 'react-async-script-loader'
import cx from 'classnames'
import { links, constants, sentry } from 'common/helpers'
import actions from 'redux/actions'
import config from 'app-config'
import { callAnalytics } from 'redux/models/payment/util'

import Button from 'components/_new/Button/Button'

import s from './PayPalPaymentButton.scss'


// TODO @vkudla combine buttons PayPalPaymentButton and UpdatePayPalButton
class PayPalPaymentButton extends Component {

  static propTypes = {
    title: PropTypes.object,
    paymentType: PropTypes.string.isRequired,
    payPalBeginAction: PropTypes.func.isRequired,
    payPalCommitAction: PropTypes.func.isRequired,

    // @scriptLoader props
    isScriptLoaded: PropTypes.bool,
    isScriptLoadSucceed: PropTypes.bool,
    client: PropTypes.object,
    env: PropTypes.string,
    onSuccess: PropTypes.func,
    onError: PropTypes.func,
    onClick: PropTypes.func,
    onCancel: PropTypes.func,
    gatewaySessionId: PropTypes.string,
  }

  static defaultProps = {
    client: {
      sandbox: 'AZDxjDScFpQtjWTOUtWKbyN_bDt4OgqaF4eYXlewfBP4-8aqX3PiV8e1GWU6liB2CUXlkA59kJXE7M6R',
      production: 'access_token$production$98cpffnjb3zxdzk6$c36851c8fec5a3854cd5036a153d7c6b',
    },
    env: config.runEnv === 'prod' ? 'production' : 'sandbox',
    onSuccess: (payment) => console.log('The payment was succeeded!', payment),
    onCancel: () => actions.models.modals.open(constants.modals.ErrorPayPal, { type: 'cancel' }),
    onError: () => actions.models.modals.open(constants.modals.ErrorPayPal, { type: 'error' }),
  }

  state = {
    isPayPalScriptLoaded: false,
  }

  handleInit = (props, wasScriptLoaded = false) => {
    const { isPayPalScriptLoaded } = this.state
    const { onError, isScriptLoaded, isScriptLoadSucceed } = props

    const isPayPalInitialized = (
      !isPayPalScriptLoaded
      && isScriptLoaded
      && !wasScriptLoaded
    )

    const handleSuccess = () => {
      this.setState({
        isPayPalScriptLoaded: true,
      })
      console.log('Init PayPal')
    }

    const handleError = () => {
      console.warn('Can\'t load PayPal scripts')
      onError()
    }

    if (isPayPalInitialized) {
      if (isScriptLoadSucceed) {
        // timeout moves executing to the next tick and
        // it will force to launch after paypal script inition
        setTimeout(() => {
          if (window.paypal && window.paypal.Button) {
            handleSuccess()
          }
          else {
            handleError()
          }
        }, 100)
      }
      else {
        handleSuccess()
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { isScriptLoaded: wasScriptLoaded } = this.props
    this.handleInit(nextProps, wasScriptLoaded)
  }

  componentDidMount() {
    this.handleInit(this.props)
  }

  onAuthorize = (data) => {
    const { paymentType, payPalCommitAction, onSuccess } = this.props
    const paypalSessionId = data.returnUrl.match(/vid=([^&]+)/)[1]

    if (this.isBeginActionComplete) {
      this.isBeginActionComplete = false

      return payPalCommitAction({
        paymentType,
        paypalSessionId,
      })
        .then((data) => {
          // TODO move closing to AddressValidationModal handler. Is it onSuccess?
          actions.models.modals.close(constants.modals.AddressValidation)

          if (paymentType !== constants.paymentTypes.updateInfo) {
            callAnalytics()
            actions.models.router.push(links.thankYou)
            return
          }

          if (typeof onSuccess === 'function') {
            onSuccess(data)
          }
        }, () => {
          actions.models.modals.close(constants.modals.AddressValidation)

          return Promise.reject()
        })
        .finally(() => actions.models.ui.hideRequestLoader())
    }

    sentry.captureException(`Call the PayPalCommitAction twice: ${JSON.stringify(data)}`)

    return Promise.reject()
  }

  payment = () => {
    const { payPalBeginAction, onClick, onError } = this.props

    // TODO that onClick returns value isn't good at all
    // Onclick return data from Address validation modal
    return onClick()
      .then(
        (data) => payPalBeginAction(data),
        (err) => {
          onError(err)

          return Promise.reject(err)
        })
      .then(
        (payPalToken) => {
          this.isBeginActionComplete = true

          return payPalToken
        })
  }

  renderPayPalBtn = () => {
    const { isPayPalScriptLoaded } = this.state
    const { client, env, onCancel } = this.props

    console.log({ isPayPalScriptLoaded })

    if (!isPayPalScriptLoaded || !window.paypal) {
      return null
    }

    const PayPalButton = window.paypal.Button.driver('react', { React, ReactDOM })

    return (
      <PayPalButton
        env={env}
        client={client}
        commit
        payment={this.payment}
        onAuthorize={this.onAuthorize}
        onCancel={onCancel}
      />
    )
  }

  render() {
    const { isPayPalScriptLoaded } = this.state
    const { children, title, className, buttonClassName, disabled, dataTestId, onError } = this.props

    return (
      <div className={cx(s.paypalBtn, className)}>
        <Button
          tag="div"
          className={cx(s.defaultBtn, buttonClassName)}
          color="brand"
          size="md"
          weight="normal"
          uppercase
          disabled={disabled}
          loading={!isPayPalScriptLoaded}
          dataTestId={dataTestId}
          onError={onError}
          title={title}
          afterNode={this.renderPayPalBtn()}
        >
          {children}
        </Button>
      </div>
    )
  }
}


export default scriptLoader(
  'https://www.paypalobjects.com/api/checkout.js'
)(PayPalPaymentButton)
